"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var _KObjectifDebourse = _interopRequireDefault(require("./components/KObjectifDebourse"));

var _Workflow = _interopRequireDefault(require("@/components/Workflow"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

require("@/mixins/workflow");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'ObjectifsDebourses',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default,
    KObjectifDebourse: _KObjectifDebourse.default,
    Workflow: _Workflow.default
  },
  data: function data() {
    return {
      refresh: 0,
      CONST: CONST,
      userCanDoAction: false,
      editKobj: true
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('objectifs_debourses').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.value, 'objectifs_debourses');
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    var _this2 = this;

    _eventBus.EventBus.$on('MODE_EDIT', function (modeEdit) {
      _this2.editKobj = !modeEdit; // pour verouiller/déverouiller le champ KObj si on est en edition des lots
    });

    _eventBus.EventBus.$on('SAVE_CANCEL', function (modeEdit) {
      // appelé quans on saisit une valeur dans le champ KObj ou si on clic sur enregistrer/save du champ KObj
      _this2.$root.modeEdit = modeEdit; // on verouille les autres champs que KObj et on masque les boutons d'actions
      // pour verouiller/déverouiller le champ KObj

      _this2.editKobj = modeEdit;
    });

    _eventBus.EventBus.$emit('REFRESH_CALCULS');

    this.refresh++;
  },
  methods: {
    // appel à partir de l'icone pour passer le lot en mode edition
    handleModeEdit: function handleModeEdit(lot) {
      // envoi le signal pour passer le lot en mode edition, traité dans le composant LotDetail
      _eventBus.EventBus.$emit('EDIT_LOT', lot.id);
    },
    handleBeforeToValidate: function handleBeforeToValidate() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.affaire.lotsDetail && _this3.affaire.lotsDetail.length > 0) {
          var notvalid = _this3.affaire.lotsDetail.filter(function (x) {
            return x.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE && (!x.coef_objectif_debourse || x.coef_objectif_debourse === '');
          });

          if (notvalid.length > 0) {
            _this3.$alert('Il existe des lignes sans coefficient d\'objectif de déboursé. Veuillez vérifier les données de la colonne "K objectif de déboursé"', 'Validation impossible', {
              confirmButtonText: 'Annuler',
              type: 'error'
            }).then(function () {
              reject(new Error());
            });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    handleBeforeValidated: function handleBeforeValidated() {
      return this.handleBeforeToValidate();
    },
    // execution des actions en base de données
    action: function action(_action, lot) {
      var _this4 = this;

      // console.log(action, lot)
      this.$loader(true);
      this.$store.dispatch('affaire/' + _action, lot).then(function (results) {
        _this4.$store.dispatch('affaire/setLotDetail', lot).then(function () {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');

          _this4.$loader(false);
        });
      }).catch(function (error) {
        _this4.$message(error);

        _this4.$loader(false);
      }).finally(function () {
        _this4.refresh++; // pour rafraichir l'écran
      });
    }
  }
};
exports.default = _default;